import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../Assets/logo.jpg';

const articles = [
  {
    id: 1,
    title: 'Optimisation des coûts cloud : Guide pratique',
    date: '13 juin 2025',
    author: 'User',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut blandit arcu in pretium molestie...',
  },
  {
    id: 2,
    title: 'Déploiement multi-cloud automatisé avec GenIaC',
    date: '12 juin 2025',
    author: 'Equipe GenIaC',
    description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium...',
  },
  {
    id: 3,
    title: 'Sécurité et conformité dans le cloud en 2025',
    date: '10 juin 2025',
    author: 'GenIaC SecOps',
    description: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores...',
  },
];

export default function Blog() {
  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans">
      {/* Header identique à Accueil */}
      <header className="flex justify-between items-center px-8 py-6 shadow-md sticky top-0 z-50 bg-white">
        <div className="flex items-center space-x-2">
          <img src={logo} alt="GenIaC Logo" className="h-20 w-auto object-contain" />
        </div>
        <nav className="flex items-center space-x-6 text-gray-700 font-medium">
          <Link to="/">Accueil</Link>
          <Link to="/solutions">Solutions</Link>
          <a href="#tarifs">Tarifs</a>
          <Link to="/home">Demo</Link>
          <Link to="/blog" className="text-blue-600">Blog</Link>
          <Link to="/login">CONNEXION</Link>
          <Link to="/register">
            <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition">
              INSCRIPTION
            </button>
          </Link>
        </nav>
      </header>

      {/* Contenu Blog */}
      <main className="px-6 md:px-12 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article) => (
            <div key={article.id} className="border rounded-lg p-6 shadow-sm hover:shadow-md transition">
              <h2 className="text-xl font-semibold text-blue-700 mb-2">{article.title}</h2>
              <p className="text-sm text-gray-500 mb-2">
                Par {article.author} — {article.date}
              </p>
              <p className="text-gray-700 mb-4">{article.description}</p>
              <button className="text-blue-600 hover:underline">Lire l'article →</button>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

